interface PartWithMspn {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  part_id?: string;
  mspn?: string;
  partNumber?: string;
  // eslint-disable-next-line @typescript-eslint/naming-convention
  part_number?: string;
}

const isPartWithMspn = (part: unknown): part is PartWithMspn => {
  if (typeof part !== 'object' || part === null) return false;

  return 'part_id' in part || 'mspn' in part || 'partNumber' in part || 'part_number' in part;
};

export const getMspn = (part: unknown) => {
  if (!isPartWithMspn(part)) return undefined;

  return part.part_id || part.mspn || part.partNumber || part.part_number;
};
